const MeetingAttendersTable = ({ attenders }) => {
  return (
    <>
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>Ad və Soyad</th>
            <th>Şirkət</th>
            <th>Şöbə</th>
            <th>Vəzifə</th>
            <th>E-poçt</th>
            <th>Telefon</th>
          </tr>
        </thead>
        {attenders.length > 0 ? (
          attenders.map((attender, index) => (
            <tbody key={attender._id}>
              <tr>
                <td>{index + 1}</td>
                <td>{attender.employeeName}</td>
                <td>{attender.companyName ? attender.companyName : "Qonaq"}</td>
                <td>
                  {attender.departmentName ? attender.departmentName : "Qonaq"}
                </td>
                <td>
                  {attender.positionName ? attender.positionName : "Qonaq"}
                </td>
                <td>
                  {attender.employeeEmail ? attender.employeeEmail : "Qonaq"}
                </td>
                <td>
                  {attender.employeePhone ? attender.employeePhone : "Qonaq"}
                </td>
              </tr>
            </tbody>
          ))
        ) : (
          <h1>Netice yoxdur</h1>
        )}
      </table>
    </>
  );
};

export default MeetingAttendersTable;
